import styled, { css } from 'styled-components'

interface PropsAlert {
  type: string;
  isOpened: boolean;
}


export const Alert = styled.div<PropsAlert>`
  position: fixed;
  left: 50%;
  top: 0;
  transform: translate(-50%, -110%);
  visibility: ${({isOpened}) => isOpened ? 'visible':'hidden'};

  ${ props => props.theme.alert }
  ${ props => props.theme.alert.types[props.type] }
  ${ props => props.theme.motion }

  .tmp-icon {
    color: ${ props => props.theme.alert.types[props.type].color }
  }

  .tmp-typography {
    color: ${ props => props.theme.alert.types[props.type].color }
  }

  .tmp-link {
    color: ${ props => props.theme.alert.types[props.type].color }
  }


  ${ props => props.isOpened && css`
    top: 0;
    transform: translate(-50%, 40%);
  `}
`

export const AlertTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${props => props.theme.title}
  > .tmp-typography {
    ${props => props.theme.title.text}
  }
  > .tmp-button-icon {
    margin-left: auto;
    &:hover{
      ${props => props.theme.title.button.states.hover}
    }
  }
`

export const AlertMessage = styled.div`
  ${props => props.theme.message}
  > .tmp-link {
    display: inline-flex;
    ${props => props.theme.link}
  }
`
